import { isStageOnLocal } from './env';

export const LOCAL_STAGING_BLACKLIST = ['searchTagsEdit', 'submitBatch'];

export const checkURLForBlacklist = (url: string): boolean => isStageOnLocal() && LOCAL_STAGING_BLACKLIST.some((value) => url.includes(value));
